//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  resetRequest,
  resetSuccess,
  resetFailure,
} from '../reducer/resetSlice';
import { fetchValidatePasscode } from '../api'; // Assuming API paths are correct
import { resetAccountSlice } from '../reducer/accountSlice';
import { resetAuthSlice } from '../reducer/authSlice';
import { resetCardLockSlice } from '../reducer/cardLockSlice';
import { resetContentfulSlice } from '../reducer/contentfulSlice';
import { resetEppSlice } from '../reducer/eppSlice';
import { resetGenerateCodeDeviceSlice } from '../reducer/generateCodeDeviceSlice';
import { resetPasskeyOtpGenerate } from '../reducer/passkeyOtpGenerateSlice';
import { resetPasskeyOtpValidate } from '../reducer/passkeyOtpValidateSlice';
import { resetPasskeyPreferences } from '../reducer/passkeyOtpPreferencesSlice';
import { resetPopupSlice } from '../reducer/popupSlice';
import { resetOffersSlice } from '../reducer/offerSlice';
import { resetPasskeyStatus } from '../reducer/passkeyStatusSlice';
import { resetPasskeyList } from '../reducer/passkeyListSlice';
import { resetPreferencesUserSlice } from '../reducer/preferencesUserSlice';
import { resetRewardsSlice } from '../reducer/rewardsSlice';
import { resetStatementsSlice } from '../reducer/statementsSlice';
import { resetTransactionsDownloadSlice } from '../reducer/transactionsDownloadSlice';
import { resetTransactionsSlice } from '../reducer/transactionsSlice';
import { resetUserAccountDetailsSlice } from '../reducer/userAccountDeatilsSlice';
import { resetUserSlice } from '../reducer/userSlice';
import { resetMyProfileSlice } from '../reducer/myProfileSlice';
import { resetAccountProtectionState } from '../reducer/accountProtectionSlice';
// import { resetValidatePasscodeSlice } from '../reducer/validatePasscodeSlice';

interface resetAction {
  type: typeof resetRequest.type;
}

// Fetch generate code for device saga
export function* fetchResetRequestSaga(
  action: resetAction
): Generator<any, void, unknown> {
  try {
    yield put(resetAccountSlice());
    yield put(resetAuthSlice());
    yield put(resetCardLockSlice());
    // yield put(resetContentfulSlice());
    yield put(resetEppSlice());
    yield put(resetGenerateCodeDeviceSlice());
    yield put(resetPasskeyPreferences());
    yield put(resetPasskeyOtpGenerate());
    yield put(resetPasskeyOtpValidate());
    yield put(resetPasskeyStatus());
    yield put(resetPasskeyList());
    yield put(resetPopupSlice());
    yield put(resetOffersSlice());
    yield put(resetPreferencesUserSlice());
    yield put(resetRewardsSlice());
    yield put(resetStatementsSlice());
    yield put(resetTransactionsDownloadSlice());
    yield put(resetTransactionsSlice());
    yield put(resetUserAccountDetailsSlice());
    yield put(resetUserSlice());
    yield put(resetMyProfileSlice());
    yield put(resetAccountProtectionState())
    // yield put(resetValidatePasscodeSlice());

    yield put(resetSuccess());
  } catch (error: any) {
    console.log('Failed to reset redux');
  }
}

// Watch generate code for device saga
export function* watchResetSaga(): Generator<any, void, unknown> {
  yield takeLatest(resetRequest.type, fetchResetRequestSaga);
}
